<template>
    <BCard>
        <ValidationObserver ref="form">
            <BForm @submit.prevent="onSubmit">
                <BRow class="mb-2"> 
                    <BCol cols="12" md="4"> <h3><b>Datos generales</b></h3> </BCol>
                </BRow>
                <BRow> 
                    <TextInputValidated vsName="Name" :vsModel.sync="provider.name" vsLabel="name" vsMd="4" vsRequired vsRules="required" />
                    <TextInputValidated vsName="Email" :vsModel.sync="provider.email" vsLabel="email" vsMd="4" vsRequired vsRules="required" />
                    <TextInputValidated vsName="Phone" :vsModel.sync="provider.phone" vsLabel="postal_code" vsMd="4" vsRequired vsRules="required"/>
                    <VSelectValidated vsName="Status" :vsModel.sync="provider.status" :vsOptions="statusOptions" :vsReduce="status=>status.value"  vsLabel="label" vsMd="4" vsRequired vsRules="required" />
                </BRow>

                <BRow class="mt-4 mb-2">
                    <BCol cols="12" md="4"> <h3><b>Dirección</b></h3> </BCol>
                </BRow>
                <BRow> 
                    <TextInputValidated vsName="Address" :vsModel.sync="provider.billing_address" vsRequired vsRules="required" vsLabel="postal_code" vsMd="4" />
                    <TextInputValidated vsName="City" :vsModel.sync="provider.billing_city" vsLabel="City" vsMd="4" vsRequired vsRules="required" />
                    <TextInputValidated vsName="Código postal" :vsModel.sync="provider.billing_postal_code" vsLabel="Código postal" vsMd="4" vsRequired vsRules="required" />
                    <VSelectValidated vsName="Province" :vsModel.sync="provider.billing_province_id" :vsOptions="provincesOptions" :vsReduce="province=>province.id" vsLabel="name" vsMd="4" vsRequired vsRules="required" />
                    <VSelectValidated vsName="País" :vsModel.sync="provider.billing_country_id" :vsOptions="countriesOptions" :vsReduce="country=>country.id" vsLabel="name" vsMd="4" vsRequired vsRules="required" />
                </BRow>

                <BRow class="mt-4 mb-2">
                    <BCol cols="12" md="6"> <h3><b>Datos de facturación</b></h3> </BCol>
                </BRow>
                <BRow>
                    <TextInputValidated vsName="NIF" :vsModel.sync="provider.billing_nif" vsLabel="NIF" vsMd="4" vsRequired vsRules="required" />
                    <TextInputValidated vsName="Cuenta bancaria" :vsModel.sync="provider.bank_account" vsLabel="Cuenta bancaria" vsMd="4" vsRequired vsRules="required" />
                    <TextInputValidated vsName="Razón social" :vsModel.sync="provider.billing_name" vsLabel="Razón social" vsMd="4" vsRequired vsRules="required" />
                    <VSelectValidated vsName="Forma jurídica" :vsModel.sync="provider.customer_type_id" :vsOptions="customerOptions" :vsReduce="type=>type.id" vsLabel="name" vsMd="4" vsRequired vsRules="required" />
                    <VSelectValidated vsName="Método de pago" :vsModel.sync="provider.payment_method_id" :vsOptions="paymentMethodsOptions" :vsReduce="pay=>pay.id" vsLabel="name" vsMd="4" vsRequired vsRules="required" />

                </BRow>
                <BRow class="mt-4 mb-2">
                    <BCol cols="12" md="4"> <h3><b>Observaciones</b></h3> </BCol>
                </BRow>
                <BRow>
                    <TextareaValidated  vsName="Notes" :vsModel.sync="provider.notes" />
                </BRow>
                
                <BRow class="mt-4">
                    <BCol cols="12" md="4" >
                        <BButton variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
                        <BButton variant="outline-secondary" type="reset" :to="{ name:'providers' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{ $t('Cancel') }} </BButton>
                    </BCol>
                </BRow>

            </BForm>
        </ValidationObserver>
    </BCard>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BButton, BCard, BCol, BForm, BRow } from 'bootstrap-vue';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import TextareaValidated from '@/components/forms/TextareaValidated.vue';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue';
import VSelectValidated from '@/components/forms/vSelectValidated.vue';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue';
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue';
import { ValidationObserver } from 'vee-validate'
import axios from '@axios';
import router from '@/router';
import { addProvider } from '@/composables/providerService'
import popups from '@/hooks/popups';

export default {
    components: { BForm, BRow, TextInputValidated, BCard, BCol, BButton, TextareaValidated, NumberInputValidated, VSelectValidated, ValidationObserver, DatepickerValidated, CheckboxValidated },
    setup() {
        const { successToast, errorToast } = popups()
        const form = ref(null);
        const countriesOptions = ref([])
        const provincesOptions = ref([])
        const customerOptions = ref([])
        const paymentMethodsOptions = ref([])
        const statusOptions = [
            { label: 'Activo', value: 1 },
            { label: 'Inactivo', value: 0 },
        ]

        const provider = ref({
            name:'',
            email:'',
            phone:'',
            notes:'',
            status:'',

            // Facturación
            bank_account:'',
            billing_name:'',
            billing_nif:'',
            billing_address:'',
            billing_city:'',
            billing_province_id:'',
            billing_postal_code:'',
            billing_country_id:'',
        })
        const onSubmit = function(){
            form.value.validate().then(success => {
                if(success){
                    createProvider(provider.value)
                }
            })
        }

        const createProvider = async function(provider) {
            let response=await addProvider(provider)

            if(response.data.success){
                successToast("Cliente creado correctamente")
                router.push({ name: 'providers' })
            } else {
                errorToast("Error creando cliente")
            }
        }
        
        axios.get('countries').then(response => {
            countriesOptions.value = response.data
        })

        axios.get('provinces').then(response => {
            provincesOptions.value = response.data
        })

        axios.get('payment-methods').then(response => {
            paymentMethodsOptions.value = response.data
        })

        axios.get('customer-types').then(response =>  {
            customerOptions.value=response.data
        })

        return {
            onSubmit,
            form,
            countriesOptions,
            paymentMethodsOptions,
            provincesOptions,
            statusOptions,
            provider,
            customerOptions
        }
    },
}
</script>

<style>

</style>